import { render, staticRenderFns } from "./AnalysesHeroSearchResults.vue?vue&type=template&id=86472490&scoped=true&"
import script from "./AnalysesHeroSearchResults.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AnalysesHeroSearchResults.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AnalysesHeroSearchResults.vue?vue&type=style&index=0&id=86472490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86472490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86472490')) {
      api.createRecord('86472490', component.options)
    } else {
      api.reload('86472490', component.options)
    }
    module.hot.accept("./AnalysesHeroSearchResults.vue?vue&type=template&id=86472490&scoped=true&", function () {
      api.rerender('86472490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/AnalysesHeroSearchResults.vue"
export default component.exports